export enum LayoutVariant {
  AUTH = "Auth",
  DASHBOARD = "Dashboard",
  HELPDESK = "Helpdesk",
}
